import axios from "axios";
import { auth } from '../firebase';

export const http = axios.create({
  baseURL: "https://aomapi-production.up.railway.app/",
  //baseURL: ""
  // baseURL: "http://localhost:8081/"
});

// Resolves once Firebase determines the initial auth state (prevents race condition on startup)
const authInitialized = new Promise(resolve => {
  const unsubscribe = auth.onAuthStateChanged(user => {
    unsubscribe();
    resolve(user);
  });
});

http.interceptors.request.use(async config => {
  try {
    await authInitialized;
    const user = auth.currentUser;

    if (user) {
      const idToken = await user.getIdToken();
      config.headers.Authorization = `Bearer ${idToken}`;
    } else {
      const idToken = localStorage.getItem('idToken');
      if (idToken) {
        
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    }

    // Sessão do segundo fator (2FA), exigida pelo backend em toda rota protegida.
    const sessao2fa = localStorage.getItem('sessao2fa');
    if (sessao2fa) {
      config.headers['X-2FA-Session'] = sessao2fa;
    }
  } catch (error) {
    console.error("Erro ao renovar token do Firebase", error);
  }

  return config;
}, error => {
  return Promise.reject(error);
});

// Quando o backend rejeita por falta/expiração do 2FA (inclui inatividade),
// limpa a sessão e devolve o usuário ao login.
http.interceptors.response.use(
  response => response,
  error => {
    const code = error.response?.data?.code;
    if (error.response?.status === 401 && code === "TWO_FACTOR_REQUIRED") {
      localStorage.removeItem('sessao2fa');
      const naTela2fa = window.location.pathname.endsWith('/2fa');
      const noLogin = window.location.pathname.endsWith('/login');
      // Não redireciona se já está no login ou no próprio passo de 2FA
      // (senão interromperia o cadastro/verificação em andamento).
      if (!naTela2fa && !noLogin) {
        window.location.assign('/aom-web-admin/login');
      }
    }
    return Promise.reject(error);
  }
);

export default http;